module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingStronghold/images/landing-stronghold-small.f03d0b33.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingStronghold/images/landing-stronghold-small.png
// module id = 3147
// module chunks = 11